// extracted by mini-css-extract-plugin
export var circle = "_a7-1";
export var exitConfirmationModal = "_a7-5";
export var iframe = "_a7-0";
export var offline = "_a7-3";
export var online = "_a7-2";
export var workstationSelectError = "_a7-4";